import { useAuth } from '../context/AuthContext';

export const useUserPermissions = () => {
  const { user, currentPlace } = useAuth();

  // Determinar permissões baseado no tipo de usuário e role na cafeteria
  const isBusinessUser = user?.userType === 'business_admin';
  const isPlaceAdmin = user?.userType === 'place_admin';
  const isPlaceOwner = currentPlace?.role === 'Owner';
  const isPlaceAdminRole = currentPlace?.role === 'Admin';
  const isPlaceManager = currentPlace?.role === 'Manager';

  // NOVO: Verificar se é superadmin baseado nos novos campos
  const isSystemSuperAdmin = user?.isSystemSuperAdmin === true;
  const isSystemAdmin = user?.businessUserRole === 'SystemAdmin';
  const isLegalAdmin = user?.businessUserRole === 'LegalAdmin';
  const isSupportAdmin = user?.businessUserRole === 'SupportAdmin';
  
  // Superadmin = BusinessUser com IsSystemSuperAdmin = true OU role SystemSuperAdmin
  const isSuperAdmin = isSystemSuperAdmin || user?.businessUserRole === 'SystemSuperAdmin';
  
  // Acesso à área legal: APENAS Superadmin, SystemAdmin ou LegalAdmin
  // PlaceAdmin NÃO deve ter acesso à área legal, apenas à modal de aceite de termos
  const canManageLegal = isSuperAdmin || isSystemAdmin || isLegalAdmin;

  // Debug: Log das permissões para identificar problemas
  // console.log('🔐 useUserPermissions Debug:', {
  //   userType: user?.userType,
  //   isSystemSuperAdmin,
  //   businessUserRole: user?.businessUserRole,
  //   isSuperAdmin,
  //   isSystemAdmin,
  //   isLegalAdmin,
  //   canManageLegal,
  //   currentPlaceRole: currentPlace?.role
  // });
  
  // Acesso à gestão de usuários: apenas superadmins
  const canManageSystemUsers = isSuperAdmin;
  
  // Acesso à gestão de cafeterias: Superadmin ou SystemAdmin
  const canManagePlaces = isSuperAdmin || isSystemAdmin;
  
  // Acesso a produtos: PlaceAdmin ou BusinessUser
  const canManageProducts = isPlaceAdmin || isBusinessUser;
  
  // Acesso a avaliações: PlaceAdmin ou BusinessUser
  const canManageReviews = isPlaceAdmin || isBusinessUser;
  
  // Acesso a analytics: PlaceAdmin ou BusinessUser
  const canViewAnalytics = isPlaceAdmin || isBusinessUser;

  return {
    isSuperAdmin,
    isSystemSuperAdmin,
    isSystemAdmin,
    isLegalAdmin,
    isSupportAdmin,
    isBusinessUser,
    isPlaceAdmin,
    isPlaceOwner,
    isPlaceAdminRole,
    isPlaceManager,
    canManageLegal,
    canManageSystemUsers,
    canManagePlaces,
    canManageProducts,
    canManageReviews,
    canViewAnalytics,
  };
};
